import './essay-view.css';
import PopSuggestion from "../common/pop-suggestion";
import NextStepCard from "./next-step-card";
import { useMediaQuery } from '@mui/material';
import '../../App.css';
import React, { useEffect, useState, useRef } from "react";
import { 
  Avatar, Button, Box, Card, Chip, chipClasses, CircularProgress, Dialog, DialogTitle, Fab, FormControl, Grid, IconButton, InputLabel,
  ListItem, ListItemAvatar, ListItemIcon, ListItemText, Typography
} from '@mui/material';
import { useTargetHighlight, waitForEls, waitForStableLayout } from './../common/app-tour-guide'
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import AssignmentIcon from '@mui/icons-material/Assignment';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import WallpaperIcon from '@mui/icons-material/Wallpaper';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import { diffChars, diffWords, diffWordsWithSpace } from 'diff';
import { AppHelper } from '../../AppHelper';
import ScanView from './scan-view';
import EssayViewQuestion from './essay-view-question';
import PopErrorAdd from './pop-error-add';
import PopGMErrors from './pop-GM-errors';
import PopSPErrors from './pop-SP-errors';
import PopVCAErrors from './pop-VCA-errors';
import PopVCXErrors from './pop-VCX-errors';
import PopComment from "../common/pop-comment";
import ScoreSubExpand from './score-sub-expand';
import EssayAttempt from '../common/essay-attempt';
import dayjs from 'dayjs';
import { QRCodeSVG } from 'qrcode.react';
import { EssayHelper } from '../../helpers/essay.helper';
import PopShare from './pop-share';
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';
import TabletIcon from '@mui/icons-material/Tablet';
const utc = require('dayjs/plugin/utc');
dayjs.extend(utc);
const configJson = require('../../config.json');

export default function EssayView(props) {
  const { drawerWidth, isClosing, openTour, essayDetailLoaded, essayFormDone, profileId, isSa, isSample, isShared, printMode, scroll2End, qrValue, userToken } = props;

  const [comments, setComments] = useState({
    GM: { list: [] },
    SP: { list: [] },
    VC: { list: [] },
    ST: { list: [] },
    OA: { list: [] },
  });
  const [grade, setGrade] = useState('P5');
  const gradeList = [
    { v: 'P1', n: 'Primary 1' },
    { v: 'P2', n: 'Primary 2' },
    { v: 'P3', n: 'Primary 3' },
    { v: 'P4', n: 'Primary 4' },
    { v: 'P5', n: 'Primary 5' },
    { v: 'P6', n: 'Primary 6' },
    { v: 'S1', n: 'Secondary 1' },
    { v: 'S2', n: 'Secondary 2' },
    { v: 'S3', n: 'Secondary 3' },
    { v: 'S4', n: 'Secondary 4 (NA)' },
    { v: 'S4E', n: 'Secondary 4 Express' },
    { v: 'S5', n: 'Secondary 5' }
  ];
  const [iamTEA, setIamTEA] = useState(false);
  const [iamTUI, setIamTUI] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isMyEssay, setIsMyEssay] = useState(false);
  const [isOK_GM, setIsOK_GM] = useState(false);
  const [isOK_SP, setIsOK_SP] = useState(false);
  const [isOK_VC, setIsOK_VC] = useState(false);
  const [isOK_ST, setIsOK_ST] = useState(false);
  const [isPopupOpen, setPopupOpen] = useState(false);
  const [isResubmitting, setIsResubmitting] = useState(false);
  const [oUser, setOUser] = useState(null);
  const [pdfDownloading, setPdfDownloading] = useState(false);
  const [popShareOpen, setPopShareOpen] = React.useState(false);
  const [popCmtText, setPopCmtText] = useState('');
  const [popCmtOpen, setPopCmtOpen] = useState(false);
  const [popCmtType, setPopCmtType] = useState('');
  const [recEssay, setRecEssay] = useState({ essayId: '', imgs: [], profileId: '', topic: '', grade: '', text: '', email: '', student: '' });
  const [recEssayC, setRecEssayC] = useState('');
  const [recGrade, setRecGrade] = React.useState('');
  const [recVersion, setRecVersion] = useState(1);
  const [startCheckStatus, setStartCheckStatus] = useState(false);
  const [popSpellingErrorsOpen, setPopSpellingErrorsOpen] = React.useState(false);
  const [scoreInfoSP, setScoreInfoSP] = React.useState({});
  const [popGMErrorsOpen, setPopGMErrorsOpen] = React.useState(false);
  const [scoreInfoGM, setScoreInfoGM] = React.useState({});
  const [scoreInfoVC, setScoreInfoVC] = React.useState({});
  const [scoreInfoVCX, setScoreInfoVCX] = React.useState({});
  const [popVCErrorsOpen, setPopVCErrorsOpen] = React.useState(false);
  const [popVCXOpen, setPopVCXOpen] = React.useState(false);
  const [wordsCount, setWordsCount] = useState(0);
  const [popErrorAddOpen, setPopErrorAddOpen] = useState(false);
  const [popErrorAddWords, setPopErrorAddWords] = useState('');
  const [popErrorAddStartIndex, setPopErrorAddStartIndex] = useState(-1);
  const [popErrorAddLine, setPopErrorAddLine] = useState('');
  const [popShowFeedbackOpen, setPopShowFeedbackOpen] = useState(false);
  const [viewMode, setViewMode] = React.useState("ORIGINAL");
  const [report, setReport] = React.useState("");
  const [improved, setImproved] = useState(false);
  const [improvedEssay, setImprovedEssay] = useState({});
  const [improvedWordCount, setImprovedWordCount] = useState(0);
    const [refreshList, setRefreshList] = React.useState(false);

  const onPopFeedback = () => {
    setPopShowFeedbackOpen(true);
  }
  const popShowFeedbackClose = () => {
    setPopShowFeedbackOpen(false);
  };

  useTargetHighlight();
  const boxOverall = useRef(null);

  useEffect(() => {
    AppHelper.apiAuditPost("P-ES", props.essayId || "");
  }, []);
  useEffect(() => {
    setViewMode("ORIGINAL");
    setReport("");
    setImproved(false);
    getImproveEssay();
    setIsMyEssay(oUser && oUser.profileId && recEssay && oUser.profileId == recEssay.profileId);
    setTimeout(() => {
      if (scroll2End) {
        const element = document.getElementById('boxWordCount');
        if (element) {
          const rect = element.getBoundingClientRect();
          const y = rect.top + window.scrollY;
          window.scrollTo({ top: y - 45, behavior: 'smooth' });
        }
      }
    }, 1000 * 1);
    commentsLoad(recEssay.essayId);
  }, [oUser, recEssay]);
  useEffect(() => {
    const boxView = document.getElementById('essayViewBox');
    if (boxView) {
      boxView.addEventListener('mouseup', onWordSelect);
    }
    return () => {
      if (boxView) {
        boxView.removeEventListener('mouseup', onWordSelect);
      }
    };
  }, [isLoading]);
  useEffect(() => {
    setStartCheckStatus(false);
    fetchUserDetail();
    const controller = new AbortController();
    if (props.essayId || (refreshList && props.essayId)) {
      const fetchSignal = controller.signal;
      fetchEssayDetail(props.essayId, fetchSignal);
    }

    return () => {
      controller.abort();
    };
  }, [props.essayId, refreshList]);

  const browseExercise = () => {
    window.open('/exercise', '_blank');
  }
  const convertNewlinesToBr = (text) => {
    if (!text) return <React.Fragment></React.Fragment>;
    text = text.replace(/<[^>]*>/g, '');
    return text.split('\n').map((line, index) => (
      <React.Fragment key={index}>
        {line}
        {index < text.split('\n').length - 1 && <br />}
      </React.Fragment>
    ));
  };
  const copyStudentEssay = () => {
    navigator.clipboard.writeText(recEssay.text);
    alert('Copied to clipboard!');
  }
  const fetchEssayDetail = async (argId, fetchSignal) => {
    var _user = AppHelper.userCacheGet();
    if (!_user) {
      _user = { token: 'NA' };
    }
    setIsLoading(true);
    setRecGrade('');
    setRecVersion(1);
    setRecEssayC('');
    var _token = _user.token;
    if (userToken && (!_token || _token == 'NA')) _token = userToken;
    var _rec = await EssayHelper.essayDetailScore(_token, argId, iamTEA);
    setIsLoading(false);
    if (!_rec) {
      return;
    }
    _rec.scores.forEach(_scTmp => {
      if (!_scTmp.eg) _scTmp.eg = [];
      if (!_scTmp.sub) _scTmp.sub = [];
    });
    setGrade(_rec.grade);
    var _grade = gradeList.find(g => g.v == _rec.grade);
    if (_grade)
      setRecGrade(_grade.n);

    if (_rec.correctionResult && _rec.correctionResult != 'NA') {
      try {
        var _jsonStr = _rec.correctionResult.replace(/({\r\n|{\n|{\r)/gm, "{");
        _jsonStr = _jsonStr.replace(/(\r\n}|\n}|\r})/gm, "}");
        _jsonStr = _jsonStr.replace(/(\r\n|\n|\r)/gm, "\\n");

        var _jsonCorr = JSON.parse(_jsonStr);
        setRecEssayC(_jsonCorr.correctedEssay);
      }
      catch (eCorr) {
        setRecEssayC(_rec.correctionResult);
      }
    }
    var _needResubmit = false;
    if (_rec.scoreResultGM && _rec.scoreResultGM.length > 0) setIsOK_GM(true);
    else {
      setIsOK_GM(false);
      _needResubmit = true;
    }
    if (_rec.scoreResultSP && _rec.scoreResultSP.length > 0) setIsOK_SP(true);
    else {
      setIsOK_SP(false);
      _needResubmit = true;
    }
    if (_rec.scoreResultVC && _rec.scoreResultVC.length > 0) setIsOK_VC(true);
    else {
      setIsOK_VC(false);
      _needResubmit = true;
    }
    if (_rec.scoreResultST && _rec.scoreResultST.length > 0) setIsOK_ST(true);
    else {
      setIsOK_ST(false);
      _needResubmit = true;
    }
    if (_needResubmit) {
    }

    setRecVersion(_rec.version);
    setWordsCount(wordCount(_rec.text));
    if ((scroll2End) && _rec.scores) {
      _rec.scores.forEach(rs => {
        rs.expand = true;
      });
    }
    setRecEssay(_rec);
    if(essayDetailLoaded) essayDetailLoaded(_rec);

    setRefreshList(false);
  }
  const fetchEssayDetail_sync = async (argId) => {
    var _user = AppHelper.userCacheGet();
    if (!_user) {
      _user = { token: 'NA' };
    }
    var _token = _user.token;
    if (userToken && (!_token || _token == 'NA')) _token = userToken;
    var _rec = await EssayHelper.essayDetailScore(_token, argId, iamTEA);
    if (!_rec) {
      return;
    }
    setRecEssay(_rec);
  }
  const fetchUserDetail = () => {
    var _user = AppHelper.userCacheGet();
    if (!_user) {
      _user = { token: 'NA' };
    }
    setOUser(_user);
    setIamTEA(_user.accountType == 'TEA');
    setIamTUI(_user.accountType == 'TUI');
  }
  const getDifferences = () => {
    if (!recEssay.text || !recEssayC) return <span></span>;
    const differences = diffWordsWithSpace(recEssay.text, recEssayC);
    return differences.map((part, index) => {
      const style = {
        color: part.added ? '#1976d2' : part.removed ? '#ef5350' : '#000',
        textDecoration: part.added ? 'underline' : part.removed ? 'line-through' : 'none',
        fontWeight: (part.added || part.removed) ? 'bold' : 'normal',
      };
      return <span key={index} style={style}>{convertNewlinesToBr(part.value)}</span>;
    });
  };
  const handleClosePopup = () => {
    setPopupOpen(false);
  };

  const onShare = async () => {
    setPopShareOpen(true);
  }

  const onDelete = async () => {
    if (!window.confirm('Are you sure you want to delete this Essay?')) return;
    var _res = await AppHelper.apiPost('api/essay/remove', { token: oUser ? oUser.token : 'NA', essayId: recEssay.essayId });
    if (!_res || !_res.status) {
      alert('ERROR: Failed to delete!');
      return;
    }
    else {
      if (essayFormDone) {
        _res.code = 'DELETE';
        _res.essayId = recEssay.essayId;
        essayFormDone(_res);
      }
    }
  };
  const onMarkDoneGM = async (argErrorCount) => {
    var _url = 'api/essay/score/update/GM';
    var _payload = { token: oUser.token, essayId: recEssay.essayId, verScore: recVersion, essayText: recEssay.text, errorCount: argErrorCount };
    var _res = await AppHelper.apiPost(_url, _payload);
    if (!_res.status) {
      return;
    }
    fetchEssayDetail_sync(recEssay.essayId);
  };
  const onMarkDoneVCA = async (argErrorCount) => {
    var _url = 'api/essay/score/update/VCA';
    var _payload = { token: oUser.token, essayId: recEssay.essayId, verScore: recVersion, essayText: recEssay.text, errorCount: argErrorCount };
    var _res = await AppHelper.apiPost(_url, _payload);
    if (!_res.status) {
      return;
    }
    fetchEssayDetail_sync(recEssay.essayId);
  };
  const onMarkDoneVCX = async (argVCXPoint) => {
    var _url = 'api/essay/score/update/VCX';
    var _payload = { token: oUser.token, essayId: recEssay.essayId, verScore: recVersion, essayText: recEssay.text, vcxPoint: argVCXPoint };
    var _res = await AppHelper.apiPost(_url, _payload);
    if (!_res.status) {
      return;
    }
    fetchEssayDetail_sync(recEssay.essayId);
  };
  const onMarkDoneSP = async (argErrorCount) => {
    var _url = 'api/essay/score/update/SP';
    var _payload = { token: oUser.token, essayId: recEssay.essayId, verScore: recVersion, essayText: recEssay.text, errorCount: argErrorCount };
    var _res = await AppHelper.apiPost(_url, _payload);
    if (!_res.status) {
      return;
    }
    fetchEssayDetail_sync(recEssay.essayId);
  };
  const onPdfDownload = async () => {
    setPdfDownloading(true);
    var _url = 'api/essay/share';
    var _payload = { token: oUser.token, essayId: recEssay.essayId, improvedEssay: improvedEssay };
    var _res = await AppHelper.apiPost(_url, _payload);
    if (!_res || !_res.status || !_res.data || !_res.data.shareId) {
      setPdfDownloading(false);
      alert('ERROR: Failed to add new share!');
      return;
    }
    var _shareUrl = AppHelper.shareUrl(_res.data.shareId);
    _shareUrl = _shareUrl.replace('/share', '/share/print');
    _shareUrl += '/' + oUser.token;
    _url = AppHelper.apiUrlGet('api/essay/pdf');
    _payload = {
      url: _shareUrl,
      grade: recEssay.grade
    };
    try {
      var _resPdf = await AppHelper.apiPost('api/essay/pdf', _payload);
      if (!_resPdf || !_resPdf.status || !_resPdf.data) {
        setPdfDownloading(false);
        alert('ERROR: Failed to download the PDF!');
        return;
      }
      const linkSource = `data:application/pdf;base64,${_resPdf.data}`;
      const downloadLink = document.createElement('a');
      const link = document.createTextNode('Click here to download');

      // Set download attributes
      downloadLink.href = linkSource;
      downloadLink.download = `${recEssay.student}_${recEssay.grade}_${recEssay.topic}_${dayjs().format('YYYY-MM-DD')}.pdf`;

      // Append the link to the body (needed for some browsers)
      downloadLink.appendChild(link);
      document.body.appendChild(downloadLink);

      // Programmatically click the link to trigger the download
      downloadLink.click();

      // Remove the link after the download is triggered
      document.body.removeChild(downloadLink);

    } catch (error) {
      console.error('Error downloading the PDF:', error);
    }
    setPdfDownloading(false);
  }
  const onWordSelect = () => {
    if (!oUser) return;
    var isPAR = oUser.accountType == "PAR";
    var isSTU = oUser.accountType == "STU";
    if (isPAR || isSTU) return;

    const selection = window.getSelection();
    if (!selection || selection.rangeCount < 1) {
      alert('selection.rangeCount', selection.rangeCount);
      return;
    }
    const range = selection.getRangeAt(0);
    const startNode = range.startContainer;
    const startOffset = range.startOffset;
    const originalText = startNode.textContent;
    const selectedText = selection.toString().trim();
    if (selectedText == '') {
      return;
    }
    const startIndex = originalText.indexOf(selectedText);
    const parentSpan = selection.anchorNode.parentElement;
    const spanIndex = Array.from(parentSpan.parentNode.children).indexOf(parentSpan);
    if (parentSpan.parentNode.children[spanIndex].style.textDecoration == 'underline') {
      alert('It should not selected the corrected word(s)!');
      return;
    }

    const spanCount = parentSpan.parentNode.children.length;
    var _essayText = '';
    var _wordIndex = 0;
    for (var i = 0; i < spanCount; i++) {
      if (parentSpan.parentNode.children[i].style.textDecoration != 'underline') {
        _essayText += parentSpan.parentNode.children[i].textContent;
        if (i < spanIndex)
          _wordIndex += parentSpan.parentNode.children[i].textContent.length;
        else if (i == spanIndex)
          _wordIndex += startIndex;
      }
    }
    _wordIndex += 1;

    const sentences = _essayText.split(/[.!]/);
    let _selectedLine = '';
    for (const sentence of sentences) {
      if (_wordIndex >= _essayText.indexOf(sentence) && _wordIndex <= _essayText.indexOf(sentence) + sentence.length) {
        _selectedLine = sentence.trim();
        break;
      }
    }
    setPopErrorAddOpen(true);
    setPopErrorAddWords(selectedText);
    setPopErrorAddStartIndex(_wordIndex);
    setPopErrorAddLine(_selectedLine);
  }
  const onScan = async () => {
    setPopupOpen(true);
  };

  const popShareClose = () => {
    setPopShareOpen(false);
  }

  const onTextSelectionChange = (arg) => {
  }
  const popCmtView = (arg, argScore) => {
    if (comments[argScore.c] && comments[argScore.c].list.length > 0) {
      setPopCmtText(comments[argScore.c].list[0].comment);
    }
    setPopCmtType(argScore.c);
    setPopCmtOpen(true);
  }
  const popCmtClose = (arg) => {
    setPopCmtOpen(false);
  }
  const popCmtSave = () => {
    commentsLoad(recEssay.essayId);
  }

  const commentsLoad = async (argEssayId) => {
    var _user = AppHelper.userCacheGet();

	if(!_user) return;
	
    setComments([]);
    var _res = await AppHelper.apiPost('api/comment/list', { token: _user.token, essayId: argEssayId });
    if (!_res.status) {
      return;
    }

    var _comments = {
      GM: { list: [] },
      SP: { list: [] },
      VC: { list: [] },
      ST: { list: [] },
      OA: { list: [] },
      CT: { list: [] },
      CR: { list: [] },
    }
    _res.data.forEach(c => {
      if (_comments[c.commentType]) {
        _comments[c.commentType].list.push(c);
      }
    });
    setComments(_comments);
  }

  const popGMErrorsClose = () => {
    setPopGMErrorsOpen(false);
  }
  const popSpellingErrorsClose = () => {
    setPopSpellingErrorsOpen(false);
  }
  const popVCErrorsClose = () => {
    setPopVCErrorsOpen(false);
  }
  const popVCXClose = () => {
    setPopVCXOpen(false);
  }
  const popErrorAddClose = () => {
    setPopErrorAddOpen(false);
  }
  const scoreExpand = (argScoreI) => {
    var _rec = { ...recEssay };
    _rec.scores[argScoreI].expand = !_rec.scores[argScoreI].expand;
    setRecEssay(_rec);
  }
  const spellingErrorsView = (arg, param = '') => {
    if (arg.c == 'SP') {
      setScoreInfoSP(arg.scoreInfo);
      setPopSpellingErrorsOpen(!popSpellingErrorsOpen);
    }
    else if (arg.c == 'GM') {
      setScoreInfoGM(arg.scoreInfo);
      setPopGMErrorsOpen(!popGMErrorsOpen);
    }
    else if (arg.c == 'VC') {
      if (param == 'VCX') {
        setScoreInfoVCX(arg.scoreInfo);
        setPopVCXOpen(!popVCXOpen);
      }
      else {
        setScoreInfoVC(arg.scoreInfo);
        setPopVCErrorsOpen(!popVCErrorsOpen);
      }
    }
  }
  const handleSplitView = () => {
    if (viewMode !== "SPLIT") {
      setViewMode("SPLIT");
    }
  }
  const handleOpenOriView = () => {
    setViewMode("ORIGINAL");
  }
  const handleOpenImproveView = async () => {
    if (!improved) {
      await generateImproveEssay();
    }
    await getImproveEssay();
    setViewMode('IMPROVE');
  }
  const handleDeleteImprovedEssay = async () => {
    if (!window.confirm("Are you sure you want to delete improved essay?")) return;
    var _url = 'api/essay/improve/remove';
    var _payload = { token: oUser.token, essayId: recEssay.essayId}
    var _res = await AppHelper.apiPost(_url, _payload);
    if (!_res.status) {
      return;
    }
    AppHelper.apiAuditPost("IMP-DEL", recEssay.essayId);
    setRefreshList(true);
  }
  const generateImproveEssay = async () => {
    setIsLoading(true);
    const report = await onReportGenerate();
    setReport(report);
    var _url = 'api/essay/improve';
    var _payload = { grade: grade, 
                     token: oUser.token, 
                     essayId: recEssay.essayId, 
                     essayReport: report, 
                     improvedByLink: window.location.href };
    var _res = await AppHelper.apiPost(_url, _payload);
    if (!_res.status) {
      return;
    }
    AppHelper.apiAuditPost("ES-IMP", recEssay.essayId);
    setImproved(true);
    setIsLoading(false);
  }
  const getImproveEssay = async () => {
    var _user = AppHelper.userCacheGet();
    if (!_user) {
      _user = { token: 'NA' };
    }
    var _token = _user.token;
    if (userToken && (!_token || _token == 'NA')) _token = userToken;
    var _url = 'api/essay/improve/get';
    var _payload = { grade: grade, token: _token, essayId: props.essayId }
    var _res = await AppHelper.apiPost(_url, _payload);
    if (!_res.status) {
      return;
    }
    if ( !_res.data.length > 0) {
      setImproved(false);
    }
    if (_res.status && _res.data.length > 0) {
      _res.data[0].essayBody = _res.data[0].essayBody.replace(/\n+/g, match => 
        match.length === 1 ? " \n\n" : match);
      
      _res.data[0].essayTitle = cleanYamlQuotes(_res.data[0].essayTitle);

      _res.data[0].improvements = _res.data[0].improvements.map(imp => cleanYamlQuotes(imp));

      setImprovedEssay(_res.data[0]);
      setImproved(true);
      setImprovedWordCount(wordCount(_res.data[0].essayBody));
    }
  }

  const cleanYamlQuotes = (str) => {
    // only strip if exactly one pair of outer "…" and none inside
    if (
      str.startsWith('"') &&
      str.endsWith('"') &&
      !str.slice(1, -1).includes('"')
    ) {
      let inner = str.slice(1, -1);
  
      // 1. “Opening” single‐quote: a single-quote after a space and before an alphanumeric
      //    e.g.  foo 'bar  →  foo "bar
      inner = inner.replace(/(\s)'(?=[A-Za-z0-9])/g, '$1"');
      // 2. Closing single-quote: after punctuation OR space OR alphanumeric character,
      //    before space, punctuation, end-of-line OR end-of-string
      //    e.g.  hello.' world  →  hello." world
      inner = inner.replace(
        /([\s.,!?;:]|[A-Za-z0-9])'(?=[\s.,!?;:]|$)/g,
        '$1"'
      );
      //Todo: To handle single quotes after a possessive word like ladies', we can check if there's an opening quote prior to the closing quote
      // This will handle the situation where such a possessive appears outside quotes, but not inside.
      return inner;
    }
    return str;
  };
  const wordCount = (_txt) => {
    if (!_txt) return 0;
    return _txt.trim().split(/\s+/).length;
  };
  const onReportGenerate = async () => {
    var content = '';
    if (recEssay.question != null) {
      content += "## Essay Question\n";
      content += "### Question Topic: **" + recEssay.question.title + "**\n";
      content += "### Writing Task: ";
      if (recEssay.question.transcribe != null) {
        const task = recEssay.question.transcribe.split('\n');
        task.forEach(line => {
          content += `\n>> ${line}`;
        });
      }
      if (recEssay.question.topic != '-') {
        const task = recEssay.question.topic.split('\n');
        task.forEach(line => {
          content += `\n>> ${line}`;
        });
      }
      content += "\n\n";
      content += "\n## Essay Answer\n";
    }
    content += "1. ### This is an Essay titled `" + recEssay.topic + "` by a `Primary " + recEssay.grade.replace("P", "") + "` student `" + recEssay.student + "` (" + recEssay.email + ").\n\n";
    const textLines = recEssay.text.split('\n');
    textLines.forEach(line => {
      content += `\n>> ${line}`;
    });

    content += "\n\n2. ### This is a corrected copy of the essay with corrections to _spelling_ and _grammar_, and improvements to _phrasing_.\n\n";

    const text = recEssayC;

    const lines = text.split('\n');
    lines.forEach(line => {
      content += `\n>> ${line}`;
    });

    content += "\n\n3. ### Score across various categories:\n\n";
    var _scoreSP = recEssay.scores.find(s => s.c == 'SP');
    var spMistakes = 0;
    if (_scoreSP.scoreInfo.levelItems0) {
      spMistakes = _scoreSP.scoreInfo.levelItems0.length;
    }
    if (_scoreSP.scoreInfo.levelItems1) {
      spMistakes += _scoreSP.scoreInfo.levelItems1.length;
    }
    if (_scoreSP.scoreInfo.levelItems2) {
      spMistakes += _scoreSP.scoreInfo.levelItems2.length;
    }

    content += '#### 3.1) Spelling: Score ' + _scoreSP.v + "/10" + ', ' + spMistakes + ' mistakes\n';

    if (_scoreSP && _scoreSP.scoreInfo) {

      if (!_scoreSP.scoreInfo.levelItems0 || _scoreSP.scoreInfo.levelItems0.length < 1) {
        content += '\n* **Easy Mistakes (' + 0 + ' mistakes)**:';
        content += 'NA';
      }
      else {
        content += '\n* **Easy Mistakes (' + _scoreSP.scoreInfo.levelItems0.length + ' mistakes)**:';
        content += '\n| Wrong Spelling | Correct Spelling |';
        content += '\n| :------------:|:-------------:|';
        _scoreSP.scoreInfo.levelItems0.forEach(ssp => {
          content += `\n| ${ssp.w} | ${ssp.r} |`;
        });
      }

      if (!_scoreSP.scoreInfo.levelItems1 || _scoreSP.scoreInfo.levelItems1.length < 1) {
        content += '\n* **Medium Mistakes (' + 0 + ' mistakes)**:';
        content += 'NA';
      }
      else {
        content += '\n* **Medium Mistakes (' + _scoreSP.scoreInfo.levelItems1.length + ' mistakes)**:';
        content += '\n| Wrong Spelling | Correct Spelling |';
        content += '\n| :------------:|:-------------:|';
        _scoreSP.scoreInfo.levelItems1.forEach(ssp => {
          content += `\n| ${ssp.w} | ${ssp.r} |`;
        });
      }

      if (!_scoreSP.scoreInfo.levelItems2 || _scoreSP.scoreInfo.levelItems2.length < 1) {
        content += '\n* **Difficult Mistakes (0 mistake)**:';
        content += 'NA';
      }
      else {
        content += '\n* **Difficult Mistakes (' + _scoreSP.scoreInfo.levelItems2.length + ' mistakes)**:';
        content += '\n| Wrong Spelling | Correct Spelling |';
        content += '\n| :------------:|:-------------:|';
        _scoreSP.scoreInfo.levelItems2.forEach(ssp => {
          content += `\n| ${ssp.w} | ${ssp.r} |`;
        });
      }
    }
    var _scoreGM = recEssay.scores.find(s => s.c == 'GM');
    var gmMistakes = 0;
    if (_scoreGM && _scoreGM.scoreInfo) gmMistakes = _scoreGM.scoreInfo.errors.length;

    content += '\n#### 3.2) Grammar: Score ' + (_scoreGM ? _scoreGM.v : 0) + "/10" + ', ' + gmMistakes + ' mistakes\n';

    content += '* **Grammar Mistakes (' + gmMistakes + ' mistakes)**:';
    if (_scoreGM && _scoreGM.scoreInfo && _scoreGM.scoreInfo.errors && _scoreGM.scoreInfo.errors.length > 0) {
      content += '\n| Wrong Sentence | Correct Sentence| Type | Subtype |';
      content += '\n| :------------:|:-------------:|:-------------:|:-------------:|';
      _scoreGM.scoreInfo.errors.forEach(eGM => {
        content += `\n| ${eGM.w} | ${eGM.r} | ${eGM.type} | ${eGM.subType} |`;
      });
    }
    else {
      content += '* **Grammar Mistakes (0 mistake)**:';
      content += 'NA';
    }

    var _scoreVC = recEssay.scores.find(s => s.c == 'VC');
    var vcMistakes = 0;

    if (_scoreVC && _scoreVC.scoreInfo) vcMistakes = _scoreVC.scoreInfo.errors.length;

    content += '\n#### 3.3) Vocabulary: Score ' + (_scoreVC ? _scoreVC.v : 0) + "/10" + ', ' + vcMistakes + ' mistakes\n';

    if (_scoreVC && _scoreVC.scoreInfo) {

      if (_scoreVC.scoreInfo.errors && _scoreVC.scoreInfo.errors.length > 0) {
        content += '* **Vocabulary Appropriateness: Score ' + (_scoreVC ? _scoreVC.v : 0) + '/10, (' + _scoreVC.scoreInfo.errors.length + ' mistakes)**:';
        content += '\n| Incorrect Usage Word | Incorrect Line | Suggested Correction | Explanation |';
        content += '\n| :------------:|:-------------:|:-------------:|:-------------:|';
        _scoreVC.scoreInfo.errors.forEach(eVC => {
          content += `\n| ${eVC.w} | ${eVC.wl} | ${eVC.sg} | ${eVC.ex} |`;
        });
      }
      else {
        content += '* **Vocabulary Appropriateness: Score ' + (_scoreVC ? _scoreVC.v : 0) + '/10, 0 mistake**:';
        content += 'NA';
      }
      if (_scoreVC.scoreInfo.rareWords && _scoreVC.scoreInfo.rareWords.length > 0) {
        content += '\n* **Vocabulary Complexity: Score ' + (_scoreVC ? _scoreVC.v : 0) + '/10, ' + _scoreVC.scoreInfo.rareWords.length + ' words**:';
        content += '\n| Word | Type |';
        content += '\n|:----:|:----:|';
        _scoreVC.scoreInfo.rareWords.forEach(rw => {
          content += `\n| ${rw.w} | ${rw.t == 'R' ? 'Rare' : rw.t == 'U' ? 'Uncommon' : '-'} |`;
        });
      }
    }

    var _scoreST = recEssay.scores.find(s => s.c == 'ST');
    content += '\n#### 3.4) Structure & Flow: Score ' + (_scoreST ? _scoreST.v : 0) + "/10";
    content += '\n* **Score Categories**:';
    content += '\n| Score | Score Category |';
    content += '\n|:---:|:---:|';
    content += '\n| 1 | Needs Improvement |';
    content += '\n| 2 | Developing |';
    content += '\n| 3 | Competent |';
    content += '\n| 4 | Proficient |';

    if (_scoreST && _scoreST.sub && _scoreST.sub.length > 0) {
      _scoreST.sub.forEach(stSub => {
        content += `${'\n\n`' + stSub.score + '/4`'} ${stSub.title}`;
        if (stSub.exampleImprovements && stSub.exampleImprovements.length > 0) {
          stSub.exampleImprovements.forEach(exi => {
            content += `\n> * ${exi}`;
          });
        }
      });
    }
    content += '\n\n';

    var _scoreCT = recEssay.scores.find(s => s.c == 'CT');
    if (_scoreCT) {
      content += '\n#### 3.5) Development: Score ' + (_scoreCT ? _scoreCT.v : 0) + "/10";
      content += '\n* **Score Categories**:';
      content += '\n| Score | Score Category |';
      content += '\n|:---:|:---:|';
      content += '\n| 1 | Needs Improvement |';
      content += '\n| 2 | Emerging |';
      content += '\n| 3 | Developing |';
      content += '\n| 4 | Competent |';
      content += '\n| 5 | Skilled |';
      content += '\n| 6 | Proficient |';

      if (_scoreCT && _scoreCT.sub && _scoreCT.sub.length > 0) {
        _scoreCT.sub.forEach(stSub => {
          content += `${'\n\n`' + stSub.score + '/6`'} ${stSub.title}`;
          if (stSub.exampleImprovements && stSub.exampleImprovements.length > 0) {
            stSub.exampleImprovements.forEach(exi => {
              content += `\n> * ${exi}`;
            });
          }
        });
      }
      content += '\n\n';
    }
    
    var _scoreCR = recEssay.scores.find(s => s.c == 'CR');
    if (_scoreCR) {
      content += '\n#### 3.6) Relevance & Logic: Score ' + (_scoreCR ? _scoreCR.v : 0) + "/10";
      content += '\n* **Score Categories**:';
      content += '\n| Score | Score Category |';
      content += '\n|:---:|:---:|';
      content += '\n| 1 | Needs Improvement |';
      content += '\n| 2 | Emerging |';
      content += '\n| 3 | Developing |';
      content += '\n| 4 | Competent |';
      content += '\n| 5 | Skilled |';
      content += '\n| 6 | Proficient |';

      if (_scoreCR && _scoreCR.sub && _scoreCR.sub.length > 0) {
        _scoreCR.sub.forEach(stSub => {
          content += `${'\n\n`' + stSub.score + '/6`'} ${stSub.title}`;
          if (stSub.exampleImprovements && stSub.exampleImprovements.length > 0) {
            stSub.exampleImprovements.forEach(exi => {
              content += `\n> * ${exi}`;
            });
          }
        });
      }
      content += '\n\n';
    }

    content += '4. ### Overall Score: `' + recEssay.avgScoreP.toFixed(2) + '%`';

    return content;

  }
  const onReportDownload = async () => {
    const content = await onReportGenerate();
    const fileName = 'essay-report.txt';

    // Create a Blob from the text
      const blob = new Blob([content], { type: 'text/plain' });
    // Create a URL for the Blob
    const url = window.URL.createObjectURL(blob);

    // Create a temporary anchor element
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;

    // Programmatically click the anchor to trigger the download
    document.body.appendChild(a);
    a.click();

    // Clean up by removing the anchor and revoking the object URL
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);

  }
  const attemptSelect = (arg)=>{
    if(essayFormDone) essayFormDone({code:'CHANGE', essayId:arg.essayId});
  }
  
  const isSmallScreen = useMediaQuery('(max-width:600px)'); // Detect small screens
  
  return (
    <>
      {!isLoading && recEssay.topic &&
        <Box sx={{ flexGrow: 1 }}>
          <Grid container>
            <Grid item xs={6}>
              {isShared &&
                <Typography sx={{ fontWeight: 'bold', color: '#666', marginRight: '0.5rem' }}>
                  {recEssay.student}
                </Typography>
              }
            </Grid>
          </Grid>
          <Box
            sx={{
              borderBottomLeftRadius: '20px', borderBottomRightRadius: '20px',
              overflowY: 'auto',
              '&::-webkit-scrollbar': {
                width: '6px',      // Width of the scrollbar
              },
              '&::-webkit-scrollbar-track': {
                background: '#f1f1f1', // Track color
              },
              '&::-webkit-scrollbar-thumb': {
                background: '#888',     // Thumb color
                borderRadius: '4px',   // Border radius
              },
              '&::-webkit-scrollbar-thumb:hover': {
                background: '#555',     // Thumb color on hover
              },
            }}>
            <Grid container>
              <Grid item xs={12} sm={12}>
                <Box display={'flex'} sx={{ fontSize: '1.2rem', fontWeight: 'bold', justifyContent: 'space-between', overflowX: 'hidden' }} ml={0}>
                  <div style={{ flexGrow: 1 }}>
                    {recGrade && (
                      <Box style={{ textTransform: 'Capitalize', marginLeft: '-1px'}} sx={{ fontSize: '1rem'}}>
                        {recGrade}
                      </Box>
                    )}
                    <div style={{ display: 'flex' }}>
                      {!isShared && configJson.allowPdf == 1 && !printMode && !pdfDownloading &&
                        <>
                          <Button onClick={onPdfDownload} variant='text' style={{ color: 'rgba(19,130,117,1)', textTransform: 'none', marginLeft: '-9px' }} endIcon={<PictureAsPdfIcon />}>
                            Download PDF
                          </Button>
                        </>
                      }
                      {pdfDownloading &&
                        <div style={{ fontSize: '0.8rem', fontWeight: 'normal' }}>Downloading..</div>
                      }
                    </div>
                  </div>
                  {((!printMode && recEssay.imgs && recEssay.imgs != undefined && recEssay.imgs.length > 0)) && (
                    <>
                      <Button onClick={onScan} variant='text' style={{ color: '#000', marginLeft: '0.5rem', marginTop: '1.4rem', textTransform: 'none' }} endIcon={<WallpaperIcon />}>Original Scan</Button>
                      <ScanView isOpen={isPopupOpen} pages={recEssay.imgs} numPages={recEssay.imgs.length} onClose={handleClosePopup} />
                    </>
                  )}
                  {!printMode &&
                    <Button onClick={copyStudentEssay} variant='text' style={{ color: '#000', marginLeft: '0.5rem', marginTop: '1.4rem', textTransform: 'none', paddingRight: '2px' }}
                      endIcon={<ContentCopyIcon />}>
                      Copy Original
                    </Button>
                  }
                </Box>
                {recEssay.question != null &&
                  <Card variant="outlined" sx={{ padding: 1.5, marginRight: 0, borderRadius: '20px', marginTop: '0.25rem', fontSize: '18px' }}>
                    <div style={{ marginBottom: '8px', fontWeight: 700 }}>Selected Question</div>
                    <div> {<EssayViewQuestion question={recEssay.question} />} </div>


                  </Card>
                }
                {improved && !printMode && 
                <>
                  {viewMode != "SPLIT" && 
                    <Grid xs={12} mb={1}
                      container
                      direction="row"
                      alignItems="center"
                      justifyContent="center"
                      sx={{marginTop: '20px'}}
                    >
                      <Grid item>
                        <Button
                          variant="contained"
                          sx={{
                            border: '1px solid green',
                            margin: '0 5px 22px 5px',
                            width: '180px',
                            textTransform: 'none',
                            background: viewMode === 'ORIGINAL' ? 'rgba(19,130,117,1)' : '#fff',
                            color: viewMode === 'ORIGINAL' ? '#fff' : 'rgba(19,130,117,1)',
                            '&:hover': {
                              background: 'rgba(52, 105, 109, 0.99)',
                              color: '#fff'
                            },
                            borderRadius: '30px', 
                          }}
                          onClick={() => { handleOpenOriView()}}
                          color="success"
                          size="medium"
                          >
                          Original Essay
                        </Button>
                      </Grid >
                      <Grid item>
                        <Button
                          size="medium"
                          variant="contained"
                          sx={{
                            border: '1px solid #3e76d6',
                            margin: '0 5px 22px 5px',
                            width: '180px',
                            textTransform: 'none',
                            background: viewMode === 'IMPROVE' ? 'linear-gradient(45deg, #6451a9 30%, #3e76d6 90%)' : '#fff',
                            color: viewMode === 'IMPROVE' ? '#fff' : '#6451a9',
                            '&:hover': {
                              background: 'linear-gradient(45deg,rgba(100, 81, 169, 0.53) 30%,rgba(0, 202, 224, 0.47) 90%)',
                            },
                            borderRadius: '30px', 
                          }}
                          startIcon={<AutoFixHighIcon />}
                          onClick={() => { handleOpenImproveView()}}
                          >
                            Improved Essay
                        </Button>
                      </Grid>
                      {isSa && 
                      <Grid item>
                        <Button
                          size="medium"
                          variant="outlined"
                          color="error"
                          sx={{
                            margin: '0 5px 22px 5px',
                            width: '200px',
                            textTransform: 'none',
                            borderRadius: '30px', 
                          }}
                          onClick={() => { handleDeleteImprovedEssay()}}
                          >
                            Delete Improved Essay
                        </Button>
                      </Grid>
                      }
                    </Grid>
                  }
                <Grid container sx={{justifyContent: 'flex-end', marginTop: viewMode == "SPLIT" ? '18px' : '-70px', marginBottom: '20px'}}>
                  <Button sx={{textTransform: 'none', marginRight: '-8px'}}
                  onClick={() => viewMode == "SPLIT" ? handleOpenOriView() : handleSplitView()}
                  startIcon={viewMode == "SPLIT" ? <TabletIcon /> : null}
                  >
                    {viewMode == "SPLIT" ? "Tab View" : "][ Split View"}
                  </Button>
                </Grid>
                </>
                }
                {viewMode == 'ORIGINAL' && 
                <Card variant="outlined" sx={{ position: 'relative', overflow: 'visible', padding: 1.5, marginRight: 0, borderRadius: '20px', marginTop: '0.25rem' }}>
                {!improved && !printMode && 
                  <Button
                  id='improve-essay-btn'
                  size="medium"
                  sx={{
                    position: 'absolute',
                    top: '20px',
                    right: '8px',
                    textTransform: 'none',
                    borderRadius: '30px', 
                    background: 'linear-gradient(45deg, #6451a9 30%, #3e76d6 90%)',
                    color: '#fff',
                    '&:hover': {
                      background: 'linear-gradient(45deg,rgba(100, 81, 169, 0.53) 30%,rgba(0, 202, 224, 0.47) 90%)',
                    },
                    fontWeight: 'bold',
                    marginRight:'4px',
                  }}
                  startIcon={<AutoFixHighIcon />}
                  onClick={() => { handleOpenImproveView()}}
                  >
                  IMPROVE MY ESSAY
                </Button>
                }

                <Grid item xs={12} mb={1}>
                  <Box sx={{ fontWeight: 'bold', fontFamily: "'Playpen Sans', cursive", fontSize: '2rem', textAlign: 'center' }}>{recEssay.topic}</Box>
                </Grid>
                <Grid item xs={12}>
                  <Box id='essayViewBox' style={{ cursor: 'context-menu' }}
                    onSelect={onTextSelectionChange}
                    sx={{
                      fontSize: '1.3rem', lineHeight: '35px', fontFamily: "'Playpen Sans', cursive",
                      background: 'linear-gradient(to bottom, white 34px, #00b0d7 1px)', backgroundSize: '100% 35px',
                      border: '0 solid #efefef', borderRadius: '6px', padding: '5px', marginLeft: '5px',
                    }}
                  >
                    {getDifferences()}
                  </Box>
            <Grid item xs={12} sm={6}>
              <Box id='boxWordCount' sx={{ mb: 1, ml: 0.65 }}>
                {wordsCount} words
              </Box>
            </Grid>
                </Grid>
                </Card>
                }
                {viewMode == 'IMPROVE' &&
                <>
                <Grid xs={12} mb={1} spacing={2}
                  container
                  direction="row"
                  alignItems="flex-start"
                  justifyContent="center"
                  sx={{}}
                >
                  <Grid item xs={12} md={4}>
                    <Card variant="outlined" sx={{ p: 2, backgroundColor: '#fff2cc' ,borderRadius: '20px', height: '100%', marginRight: '0.5rem'}}>
                      <Box sx={{fontWeight: 'bold', fontFamily: "'Playpen Sans', cursive", fontSize: '17px'}}>
                        How the essay was improved:
                      </Box> 
                      {improvedEssay.improvements.map((rec, i) => (
                        <Box sx={{fontWeight: '', fontFamily: "'Playpen Sans', cursive", fontSize: '17px'}}>
                          {i+1}. {rec}
                        </Box>
                      ))}
                    </Card>
                  </Grid>
                  <Grid item xs={12} md={8}>
                  <Card variant="outlined" sx={{ padding: 1.5, marginRight: 0, borderRadius: '20px' }}>
                    <Grid item xs={12}>
                    <Box 
                      sx={{ 
                        fontWeight: 'bold', 
                        fontFamily: "'Playpen Sans', cursive", 
                        fontSize: '2rem', 
                        textAlign: 'center',
                        userSelect: 'none', 
                        WebkitUserSelect: 'none', 
                        MozUserSelect: 'none',  
                      }}
                      onCopy={e => e.preventDefault()}
                    >
                      {improvedEssay.essayTitle}
                      </Box>
                    </Grid>
                    <Grid item xs={12}>
                      <Box id='essayViewBox' style={{ cursor: 'context-menu' }}
                        sx={{
                          fontSize: '1.3rem', lineHeight: '35px', fontFamily: "'Playpen Sans', cursive",
                          background: 'linear-gradient(to bottom, white 34px, #00b0d7 1px)', backgroundSize: '100% 35px',
                          border: '0 solid #efefef', borderRadius: '6px', padding: '5px', marginLeft: '5px',
                          userSelect: 'none',
                          WebkitUserSelect: 'none',
                          MozUserSelect: 'none',
                        }}
                        onCopy={e => e.preventDefault()}
                      >
                        {convertNewlinesToBr(improvedEssay.essayBody)}
                      </Box>
            <Grid item xs={12} sm={6}>
              <Box id='boxWordCount' sx={{ mb: 1 }}>
                {improvedWordCount} words
              </Box>
            </Grid>
                    </Grid>
                  </Card>
                  </Grid>
                </Grid>
                </>
                }
                {viewMode === 'SPLIT' &&
                <>
                <Grid xs={12} mb={1}
                  container
                  direction="row"
                  alignItems="relative"
                  justifyContent="center"
                >
                  <Grid item xs={6}>
                    <div style={{ marginBottom: '8px' }}>Original Essay</div>
                    <Card variant="outlined" sx={{ position: 'relative', padding: 1.5, marginRight: 1, marginLeft: 0, borderRadius: '20px' }}>
                    <Grid item xs={12} mb={1}>
                      <Box sx={{ fontWeight: 'bold', fontFamily: "'Playpen Sans', cursive", fontSize: '2rem', textAlign: 'center' }}>{recEssay.topic}</Box>
                    </Grid>
                    <Grid item xs={12}>
                      <Box id='essayViewBox' style={{ cursor: 'context-menu' }}
                        onSelect={onTextSelectionChange}
                        sx={{
                          fontSize: '1.3rem', lineHeight: '35px', fontFamily: "'Playpen Sans', cursive",
                          background: 'linear-gradient(to bottom, white 34px, #00b0d7 1px)', backgroundSize: '100% 35px',
                          border: '0 solid #efefef', borderRadius: '6px', padding: '5px', marginLeft: '5px',
                        }}
                      >
                        {getDifferences()}
                      </Box>
            <Grid item xs={12} sm={6}>
              <Box id='boxWordCount' sx={{ mb: 1 }}>
                {wordsCount} words
              </Box>
            </Grid>
                    </Grid>
                    </Card>
                  </Grid>
                  <Grid item xs={6}>
                    <div style={{ marginBottom: '8px' }}>Improved Essay</div>
                    <Card variant="outlined" sx={{ position: 'relative', padding: 1.5, marginRight: 0, marginLeft: 1, borderRadius: '20px' }}>
                      <Grid item xs={12}>
                        <Box 
                          sx={{ 
                            fontWeight: 'bold', 
                            fontFamily: "'Playpen Sans', cursive", 
                            fontSize: '2rem', 
                            textAlign: 'center',
                            userSelect: 'none', 
                            WebkitUserSelect: 'none', 
                            MozUserSelect: 'none',  
                          }}
                          onCopy={e => e.preventDefault()}
                        >
                        {improvedEssay.essayTitle}
                        </Box>
                      </Grid>
                      <Grid item xs={12}>
                        <Box id='essayViewBox' style={{ cursor: 'context-menu' }}
                          sx={{
                            fontSize: '1.3rem', lineHeight: '35px', fontFamily: "'Playpen Sans', cursive",
                            background: 'linear-gradient(to bottom, white 34px, #00b0d7 1px)', backgroundSize: '100% 35px',
                            border: '0 solid #efefef', borderRadius: '6px', padding: '5px', marginLeft: '5px',
                            userSelect: 'none',
                            WebkitUserSelect: 'none',
                            MozUserSelect: 'none',
                          }}
                          onCopy={e => e.preventDefault()}
                        >
                          {convertNewlinesToBr(improvedEssay.essayBody)}
                        </Box>
            <Grid item xs={12} sm={6}>
              <Box id='boxWordCount' sx={{ mb: 1 }}>
                {improvedWordCount} words
              </Box>
            </Grid>
                      </Grid>
                    </Card>
                  </Grid>
                </Grid>
                </>
                }
              </Grid>
            </Grid>
          </Box>
          <Grid container>
            <Grid item xs={12} sm={6}>
              <Box id='boxWordCount' sx={{ mb: 1 }}>
              </Box>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Box sx={{ mb: 1 }}>
              </Box>
            </Grid>
          </Grid>
          <Grid container pt={.5}>
            <Grid item xs={12} md={recVersion == 1 ? 6 : 12}>
              {recEssay && recVersion >= 3 && <NextStepCard scores={recEssay.scores} suggestions={recEssay.suggestions} grade={grade} />}
              <Card id="score-section" variant="outlined" sx={{ padding: 1.5, marginRight: 0, borderRadius: '20px' }}>
                {recEssay && recVersion >= 3 &&
                  <>
                    <div id="boxPageBreak"></div>
                    <Box display='flex' width='100%' style={{ marginBottom: '1rem' }}>
                      <Box flexGrow={1}>
                        <Box id='boxScoreTitle' sx={{ fontWeight: 'bold', fontSize: '2rem' }}>SCORE</Box>
                        <Box>
                          {recEssay && recEssay.scores && recEssay.scores.map((sc, iSc) => (
                            <Grid container mb={0.6} key={'score_' + iSc}>
                              <Grid item xs={12}>
                                <Box display='flex' width='100%'>
                                  <Box flexGrow={1} paddingRight={'.2rem'}>
                                    <Box flexGrow={1}
                                      sx={{
                                        border: '1px solid #333', backgroundColor: '#fff', color: '#fff', borderRadius: '50px', display: 'flex',
                                        whiteSpace: 'nowrap',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis'
                                      }}>
                                      <Box className='app-bg-g' sx={{
                                        borderRadius: '50px',
									
										fontSize: isSmallScreen ? '0.8rem' : '1rem',
                                        width: `${sc.p}%`, height: '100%', padding: '3px 0 3px 15px', alignItems: 'center', display: 'flex', fontWeight: 'bold'
										
                                      }}>
                                        {sc.v}/{recEssay.version >= 3 ? '10' : '4'} {isSmallScreen ? sc.n.split(' ')[0] : sc.n}
                                      </Box>
                                    </Box>
                                  </Box>
                                  <Box>
                                    {isResubmitting &&
                                      <span>Resubmitting..</span>
                                    }
                                    {sc.eg && (sc.eg.length > 0 || sc.c == 'VC') && (
                                      <>
                                        <Chip id='score-expand' onClick={() => scoreExpand(iSc)}
                                          icon={sc.expand ? <RemoveCircleOutlineIcon /> : <AddCircleOutlineIcon />} label={sc.eg.length > 0 ? sc.eg.length : ''}
                                          className='app-bg-g'
                                          sx={{
                                            color: '#fff',
                                            fontWeight: 'bold',
                                            [`& .${chipClasses.icon}`]: {
                                              color: '#fff'
                                            },
                                            width: '65px'
                                          }}
                                        />
                                      </>
                                    )}

                                    {(iamTUI || iamTEA) && !isSample && !isShared && isMyEssay &&
                                      (sc.c != 'GM' || isOK_GM) && (sc.c != 'SP' || isOK_SP) &&
                                      (sc.c != 'VC' || isOK_VC) && (sc.c != 'ST' || isOK_ST) &&
                                      <Chip onClick={() => popCmtView(iSc, sc)}
                                        icon={<img src='../../img/teacher.png' style={{ width: '23px', height: '23px', marginTop: '0', marginBottom: '0' }} />}
                                        label={'Comment'}
                                        className='app-bg-g'
                                        sx={{
                                          color: '#fff',
                                          fontWeight: 'bold', marginLeft: '2px',
                                          [`& .${chipClasses.icon}`]: {
                                            color: '#fff'
                                          }
                                        }}
                                      />
                                    }
                                  </Box>
                                </Box>
                              </Grid>

                              {sc.expand && sc.sub &&
                                <ScoreSubExpand recordSc={sc} scoreCode={sc.c} records={sc.sub} essay={recEssay} grade={grade} allowMark={(iamTEA || iamTUI) && !isShared && isMyEssay} />
                              }
                              {sc.expand && sc.scoreInfo &&
                                <Grid container>
                                  <Grid item xs={12}>
                                    <Box>
                                      {sc.scoreInfo.blocks && sc.scoreInfo.blocks.length > 0 && (
                                        <>
                                          <Box>
                                            <Typography sx={{ fontWeight: 'bold', color: '#666', marginRight: '0', marginLeft: '1rem' }}>
                                              {sc.scoreInfo.blocks[0].title}
                                              {!sc.scoreInfo.blocks[0].hide && (
                                                <>
                                                  {sc.c == 'VC' &&
                                                    <span onClick={() => spellingErrorsView(sc)} className='showMoreLess'>
                                                      {popVCErrorsOpen ? " Show Less" : " Show More"}
                                                    </span>
                                                  }
                                                </>
                                              )}
                                            </Typography>
                                          </Box>
                                          {sc.c == 'VC' && popVCErrorsOpen &&
                                            <PopVCAErrors
                                              open={popVCErrorsOpen} onClose={popVCErrorsClose}
                                              scoreInfo={recEssay.scores.find(s => s.c === 'VC')?.scoreInfo || {}}
                                              essay={recEssay}
                                              allowMark={(iamTEA || iamTUI) && !isShared && isMyEssay}
                                              onMarkDone={onMarkDoneVCA}
                                            />
                                          }
                                          {sc.scoreInfo.blocks[0].subTitles && sc.scoreInfo.blocks[0].subTitles.map((rSubT, iSubT) => (
                                            <Box key={iSubT}>
                                              <Grid item xs={12} mt={0}>
                                                <Box display={'flex'} alignItems={'center'}>
                                                  <Typography sx={{ fontWeight: 'normal', color: '#666', marginRight: '0', marginLeft: '1rem' }}>
                                                    {rSubT}
                                                  </Typography>
                                                </Box>
                                              </Grid>
                                            </Box>
                                          ))}
                                        </>
                                      )}
                                      {(!sc.scoreInfo.blocks || sc.scoreInfo.blocks.length < 1) && (
                                        <>
                                          <Box>
                                            <Typography sx={{ fontWeight: 'bold', color: '#666', marginRight: '0', marginLeft: '1rem' }}>
                                              {sc.scoreInfo.title}
                                              {sc.c == 'GM' &&
                                                <span onClick={() => spellingErrorsView(sc)} className='showMoreLess'>
                                                  {popGMErrorsOpen ? " Show Less" : " Show More"}
                                                </span>
                                              }
                                              {sc.c == 'SP' &&
                                                <span onClick={() => spellingErrorsView(sc)} className='showMoreLess'>
                                                  {popSpellingErrorsOpen ? " Show Less" : " Show More"}
                                                </span>
                                              }
                                            </Typography>
                                          </Box>
                                          <Box>
                                            {sc.c == 'GM' && popGMErrorsOpen &&
                                              <PopGMErrors
                                                open={popGMErrorsOpen} onClose={popGMErrorsClose}
                                                scoreInfo={recEssay.scores.find(s => s.c === 'GM')?.scoreInfo || {}}
                                                essay={recEssay}
                                                allowMark={(iamTEA || iamTUI) && !isShared && isMyEssay}
                                                onMarkDone={onMarkDoneGM}
                                              />
                                            }
                                            {sc.c == 'SP' && popSpellingErrorsOpen &&
                                              <PopSPErrors
                                                open={popSpellingErrorsOpen} onClose={popSpellingErrorsClose}
                                                scoreInfo={recEssay.scores.find(s => s.c === 'SP')?.scoreInfo || {}}
                                                essay={recEssay}
                                                allowMark={(iamTEA || iamTUI) && !isShared && isMyEssay}
                                                onMarkDone={onMarkDoneSP}
                                              />
                                            }
                                          </Box>
                                        </>
                                      )}
                                    </Box>
                                  </Grid>
                                  {sc.scoreInfo.blocks && sc.scoreInfo.blocks.length > 1 && (
                                    <Grid item xs={12} mt={0.5}>
                                      <Box>
                                        <Typography sx={{ fontWeight: 'bold', color: '#666', marginRight: '0', marginLeft: '1rem' }}>
                                          {sc.scoreInfo.blocks[1].title}
                                          {sc.c == 'VC' &&
                                            <span onClick={() => spellingErrorsView(sc, 'VCX')} className='showMoreLess'>
                                              {popVCXOpen ? " Show Less" : " Show More"}
                                            </span>
                                          }
                                        </Typography>
                                      </Box>
                                      {sc.c == 'VC' && popVCXOpen &&
                                        <PopVCXErrors
                                          open={popVCXOpen} onClose={popVCXClose}
                                          scoreInfo={recEssay.scores.find(s => s.c === 'VC')?.scoreInfo || {}}
                                          essay={recEssay}
                                          allowMark={(iamTEA || iamTUI) && !isShared && isMyEssay}
                                          onMarkDone={onMarkDoneVCX}
                                        />
                                      }
                                      {sc.scoreInfo.blocks[1].subTitles && sc.scoreInfo.blocks[1].subTitles.map((rSubT, iSubT) => (
                                        <Grid item xs={12} mt={0} key={iSubT}>
                                          <Box display={'flex'} alignItems={'center'}>
                                            <Typography sx={{ fontWeight: 'normal', color: '#666', marginRight: '0', marginLeft: '1rem' }}>
                                              {rSubT}
                                            </Typography>
                                          </Box>
                                        </Grid>
                                      ))}
                                    </Grid>
                                  )}
                                  {sc.scoreInfo.subTitles && sc.scoreInfo.subTitles.map((rSubT, iSubT) => (
                                    <Grid item xs={12} mt={0} key={iSubT}>
                                      <Box display={'flex'} alignItems={'center'}>
                                        <Typography sx={{ fontWeight: 'normal', color: '#666', marginRight: '0', marginLeft: '1rem' }}>
                                          {rSubT}
                                        </Typography>
                                      </Box>
                                    </Grid>
                                  ))}
                                </Grid>
                              }
                              <Grid item xs={10}>
                                {comments[sc.c] && comments[sc.c].list.length > 0 &&
                                  comments[sc.c].list.map(cmm => (
                                    <>
                                      <div style={{ fontSize: '0.8rem', display: 'flex', }}>
                                        <div>
                                          <img src='../../img/teacher-dark.png' style={{ width: '23px', height: '23px', marginRight: '3px', marginBottom: '0' }} />
                                        </div>
                                        <div className='line-cmt' style={{ marginTop: '3px' }}>
                                          <span style={{ color: 'rgba(0,0,0,0.8)', letterSpacing: 1 }}>Tutor's comment:</span>{' ' + cmm.comment}
                                        </div>
                                      </div>
                                    </>
                                  ))
                                }
                              </Grid>
                            </Grid>
                          ))}
                        </Box>
                      </Box>
                      <Box>
                        {printMode && qrValue &&
                          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', paddingLeft: '1rem' }}>
                            <div style={{ textAlign: 'center', marginTop: 0, borderRadius: '0' }}>
                              <div style={{ color: "rgba(19,130,117,1)", fontWeight: '900', textAlign: 'center', marginBottom: '.5rem', lineHeight: 1.1 }}>Scan the QR Code <br />for detailed feedback!</div>
                              <QRCodeSVG
                                id='boxQR'
                                value={qrValue}
                                size={150}
                                level={"Q"} includeMargin={false}
                                fgColor={"rgba(19,130,117,1)"}
                                style={{ borderRadius: '0' }}
                              />
                            </div>
                          </div>
                        }
                      </Box>
                    </Box>
                    <Grid item xs={12}>
                      <Box display='flex' width='100%'>
                        <Box flexGrow={1} paddingRight={'.2rem'}>
                          <Box sx={{ border: '1px solid #333', backgroundColor: '#fff', color: '#fff', borderRadius: '50px', marginBottom: '4px' }} flexGrow={1}>
                            <Box ref={boxOverall} id="boxOverall" sx={{ borderRadius: '50px', backgroundColor: '#1976d2', padding: '3px 0 3px 15px', width: `${recEssay.avgScoreP}%`, height: '100%', alignItems: 'center', display: 'flex', fontWeight: 'bold' }}>
                              Overall {Math.round(recEssay.avgScoreP)}%
                            </Box>
                          </Box>
                        </Box>
                        <Box>
                          {!printMode &&
                            <>
                              <div style={{ width: '65px' }}></div>
                              {(iamTUI || iamTEA) && !isSample && !isShared && isMyEssay &&
                                <Chip onClick={() => popCmtView(-1, { c: 'OA' })}
                                  icon={<img src='../../img/teacher.png' style={{ width: '23px', height: '23px',  marginTop: '0', marginBottom: '0' }} />}
                                  label={'Comment'}
                                  className='app-bg-g'
                                  sx={{
                                    color: '#fff',
                                    fontWeight: 'bold', marginLeft: '2px',
                                    [`& .${chipClasses.icon}`]: {
                                      color: '#fff'
                                    }
                                  }}
                                />
                              }
                            </>
                          }
                        </Box>
                      </Box>
                    </Grid>
                  </>
                }
              </Card>
            </Grid>
{/* 
            new Feature: PDF download */}
            {printMode && improved && (
              <Box sx={{mt: 0}}>
                <Grid xs={12}
                  container
                  direction="row"
                  alignItems="center"
                  justifyContent="center"
                  sx={{marginTop: '25px'}}
                >
                  <Grid item>
                    <Button
                      size="medium"
                      variant="contained"
                      sx={{
                        boxShadow: "none",
                        border: '1px solid #3e76d6',
                        margin: '0 5px 22px 5px',
                        width: '180px',
                        textTransform: 'none',
                        background: 'linear-gradient(45deg, #6451a9 30%, #3e76d6 90%)',
                        color: '#fff',
                        borderRadius: '30px', 
                      }}
                      startIcon={<AutoFixHighIcon />}
                      >
                        Improved Essay
                    </Button>
                  </Grid>
                </Grid>

                <Grid spacing={2}
                id="improvedEssaySection"
                  container
                  direction="row"
                  alignItems="flex-start"
                  justifyContent="center"
                  sx={{}}
                >
                    <Grid item xs={12} sx={{}} > 
                    <Card variant="outlined" sx={{ position: 'relative', overflow: 'visible', padding: 1.5, marginRight: 0, borderRadius: '20px', marginTop: '0.25rem' }}>
                      <Grid item xs={12}>
                        <Box sx={{ fontWeight: 'bold', fontFamily: "'Playpen Sans', cursive", fontSize: '2rem', textAlign: 'center' }}>
                        {improvedEssay.essayTitle}
                        </Box>
                      </Grid>
                      <Grid item xs={12}>
                        <Box id='essayViewBox' data-ready={!isLoading} style={{ cursor: 'context-menu' }}
                          sx={{
                            fontSize: '1.3rem', lineHeight: '35px', fontFamily: "'Playpen Sans', cursive",
                            background: 'linear-gradient(to bottom, white 34px, #00b0d7 1px)', backgroundSize: '100% 35px',
                            border: '0 solid #efefef', borderRadius: '6px', padding: '5px', marginLeft: '5px',
                            whiteSpace: 'pre-line'
                          }}
                        >
                          {convertNewlinesToBr(improvedEssay.essayBody)}
                        </Box>
              <Grid item xs={12} sm={6}>
                <Box id='boxWordCount' sx={{ padding: 1 }}>
                  {improvedWordCount} words
                </Box>
              </Grid>
                      </Grid>
                    </Card>
                    </Grid>
                    
                    <Grid item width="100%">
                    <Card variant="outlined" sx={{ p: 2, backgroundColor: '#fff2cc' ,borderRadius: '20px', height: '100%'}}>
                      <Box sx={{fontWeight: 'bold', fontFamily: "'Playpen Sans', cursive", fontSize: '17px'}}>
                        How the essay was improved:
                      </Box> 
                      {improvedEssay.improvements.map((rec, i) => (
                        <Box sx={{fontWeight: '', fontFamily: "'Playpen Sans', cursive", fontSize: '17px'}}>
                          {i+1}. {rec}
                        </Box>
                      ))}
                    </Card>
                    </Grid>
                </Grid>
                </Box>
                )}
            <Grid item xs={12} md={6} pl={0}>
              {recEssay && recEssay.suggestions && recEssay.suggestions.length > 0 &&
                <Card variant="outlined" sx={{ padding: 1.5, marginRight: 0, borderRadius: '20px' }}>
                  <Grid item xs={12}>
                    <Box sx={{ fontWeight: 'bold', fontSize: '2rem' }}>SUGGESTIONS</Box>
                  </Grid>
                  <Grid item xs={12}>
                    {recEssay && recEssay.suggestions && recEssay.suggestions.map((sg, iSg) => (
                      <ListItem key={'sug_' + iSg} sx={{ alignItems: 'flex-start' }}>
                        <ListItemIcon sx={{ minWidth: '40px' }}>
                          <AssignmentIcon sx={{ color: 'rgb(157, 188, 152)', marginTop: '8px' }} />
                        </ListItemIcon>
                        <ListItemText
                          primary={sg}
                        />
                      </ListItem>
                    ))}
                  </Grid>
                </Card>
              }
            </Grid>
            
            <EssayAttempt essayId={props.essayId} attemptSelect={attemptSelect} />
            <Grid item xs={12}>
              <Grid container>
                <Grid item xs={6} mt={1}>
                  {!isSample && !isShared && (oUser && oUser.token != 'NA') && (
                    <>
                      {isMyEssay &&
                        <>
                          <Button onClick={onDelete} color="error" variant="outlined" style={{ marginRight: '2px' }}>DELETE</Button>
                          {<Button onClick={onShare} color="success" variant="outlined" style={{ marginRight: '2px' }}>SHARE</Button>}
                        </>
                      }
                      {isSa && (
                        <>
                          <Button style={{ marginRight: '2px' }} onClick={onReportDownload} color="success" variant="outlined" >
                            REPORT
                          </Button>
                        </>
                      )}

                      <Button
                        onClick={onPopFeedback} color="success" variant="outlined">Feedback</Button>
                    </>
                  )}
                </Grid>
                <Grid item xs={6} mt={1} style={{ textAlign: 'right' }}>
                  {isSa &&
                    <Chip label='EXERCISE'
                      onClick={() => browseExercise()}
                      icon={<OpenInNewIcon />}
                      className='app-bg-g'
                      sx={{
                        color: '#fff',
                        fontWeight: 'bold', marginLeft: '5px', marginRight: '5px',
                        [`& .${chipClasses.icon}`]: {
                          color: '#fff'
                        }
                      }}
                    />
                  }
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      }
      {isLoading &&
        <CircularProgress />
      }

      <PopShare
        open={popShareOpen} onClose={popShareClose}
        scoreInfo={scoreInfoVCX}
        essay={recEssay}
        allowMark={iamTEA}
        onMarkDone={onMarkDoneVCX}
      />
      <PopComment
        essayId={recEssay.essayId}
        scoreType={popCmtType}
        commentText={popCmtText}
        open={popCmtOpen} onClose={popCmtClose}
        onSave={popCmtSave}
      />
      <PopErrorAdd
        open={popErrorAddOpen} onClose={popErrorAddClose}
        essay={recEssay}
        popErrorAddLine={popErrorAddLine}
        words={popErrorAddWords}
      />

      <PopSuggestion
        open={popShowFeedbackOpen}
        onClose={popShowFeedbackClose}
        essayId={recEssay.essayId}
      />
    </>
  );
}